import React, { useState, useEffect } from 'react'
import { useKhTJQuery } from '../../store/DianShangYeWuApi'
import { Form, Flex, DatePicker, Space, Table } from 'antd'
import Icon from '../../cpn/Icon'
import dayjs from 'dayjs'
import classes from '../statistic.module.css'
import ClientSelect from '../../system/client/ClientSelect'
import IncomeCheck from '../../document/income/IncomeCheck'
import CostCheck from '../../document/cost/CostCheck'
import ExpenseCheck from '../../document/expense/ExpenseCheck'
import LoanCheck from '../../document/loan/LoanCheck'
function StatisticArapClientDetail(props) {
    const [form] = Form.useForm();
    const [query, setQuery] = useState({
        date_s: localStorage.getItem('jtg-caiwu_arap_client_detail_date_s') || '',
        date_e: localStorage.getItem('jtg-caiwu_arap_client_detail_date_e') || '',
        kh_id: localStorage.getItem('jtg-caiwu_arap_client_detail_kh_id') || '',
    });
    const [list, setList] = useState([]);
    const {data,isSuccess} = useKhTJQuery({qy_id:props.qy_id,date_s:query.date_s,date_e:query.date_e,kh_id:query.kh_id}, { refetchOnMountOrArgChange: true,skip:query.date_s==='' || query.date_e===''});
    const formatAmount = (amount) => {
        if(amount){
            return Number(amount).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }else{
            return '0.00';
        }
    }
    const columns = [
        {
            title: '客户名称',
            dataIndex: 'kh_name',
            key: 'kh_name',
            render: (text, record) => {
                if(record.danju_type === '收款单'){
                    return <IncomeCheck ddsr_kh_name={record.kh_name} ddsr_kh_id={record.kh_id} qy_name={record.qy_name} qy_id={record.qy_id} yh_id={record.yh_id} yh_name={record.yh_name} ddsr_id={record.danju_id}/>;
                }else if(record.danju_type === '付款单'){
                    return <CostCheck ddzc_kh_name={record.kh_name} ddzc_kh_id={record.kh_id} qy_name={record.qy_name} qy_id={record.qy_id} yh_id={record.yh_id} yh_name={record.yh_name} ddzc_id={record.danju_id}/>;
                }else if(record.danju_type === '费用单'){
                    return <ExpenseCheck fy_kh_name={record.kh_name} fy_kh_id={record.kh_id} qy_name={record.qy_name} qy_id={record.qy_id} yh_id={record.yh_id} yh_name={record.yh_name} fy_id={record.danju_id}/>;
                }else if(record.danju_type === '借款单'){
                    return <LoanCheck jk_kh_name={record.kh_name} jk_kh_id={record.kh_id} qy_name={record.qy_name} qy_id={record.qy_id} yh_id={record.yh_id} yh_name={record.yh_name} jk_id={record.danju_id}/>;
                }else{
                    return '未知';
                }
            }
        },
        {
            title: '日期',
            key: 'danju_date',
            dataIndex: 'danju_date',
        },
        {
            title: '单据类型',
            key: 'danju_type',
            dataIndex: 'danju_type',
        },
        {
            title: '单据金额',
            key: 'danju_amount',
            dataIndex: 'danju_amount',
            render: (text, record) => {
                return <span>￥{formatAmount(text)}</span>
            }
        },
        {
            title: '往来类型',
            dataIndex: 'danju_zflx',
            key: 'danju_zflx',           
        },
        {
            title: '往来金额',
            dataIndex: 'danju_amount',
            key: 'danju_amount',
            render: (text, record) => {
                console.log(record.danju_zflx);
                
                if(record.danju_zflx === '应收' || record.danju_zflx === '核销应付'){
                    return <span style={{color:'red'}}>￥{formatAmount(text)}</span>
                }else if(record.danju_zflx === '应付' || record.danju_zflx === '核销应收'){
                    return <span style={{color:'green'}}>￥{formatAmount(Number(text)*-1)}</span>
                }else{
                    return <span>无</span>
                }
            }
        },
        {
            title: '新增记录',
            dataIndex: 'danju_uname',
            key: 'danju_uname',
            render: (text, record) => <span>{record.danju_uname} {record.danju_ctime}</span>
        },
        {
            title: '编号',
            dataIndex: 'danju_id',
            key: 'danju_id',
        },        
    ]
    useEffect(() => {
       if(isSuccess){
        if(data.Status==='success'){
            setList(Array.isArray(data.Result) ? data.Result : []);
        }else{
            setList([]);
        }
       }else{
        setList([]);
       }
    }, [isSuccess,data]);
    return (
        <>
            <Flex justify='flex-start'>
                <Form
                    layout='inline'
                    name='form_op'
                    form={form}
                    onFinish={(values) => {
                        setQuery(prev => ({
                            ...prev,
                            date_s: values.date_range[0] ? dayjs(values.date_range[0]).format('YYYY-MM-DD') : '',
                            date_e: values.date_range[1] ? dayjs(values.date_range[1]).format('YYYY-MM-DD') : '',
                        }))
                        localStorage.setItem('jtg-caiwu_arap_client_detail_date_s', values.date_range[0] ? dayjs(values.date_range[0]).format('YYYY-MM-DD') : '')
                        localStorage.setItem('jtg-caiwu_arap_client_detail_date_e', values.date_range[1] ? dayjs(values.date_range[1]).format('YYYY-MM-DD') : '')
                        localStorage.setItem('jtg-caiwu_arap_client_detail_kh_id', values.kh_id)
                    }}
                    initialValues={{
                        date_range: [],
                        date_s: localStorage.getItem('jtg-caiwu_arap_client_detail_date_s') || '',
                        date_e: localStorage.getItem('jtg-caiwu_arap_client_detail_date_e') || '',
                        kh_id: localStorage.getItem('jtg-caiwu_arap_client_detail_kh_id') || '',
                    }}
                >
                    <ClientSelect
                        name='kh_id'
                        wrapperCol={null}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        style={{width:'300px'}}
                        onChange={(value) => {
                            setQuery(prev => ({
                                ...prev,
                                kh_id: value,
                            }))
                        }}
                        placeholder='请选择客户'
                    />
                    <Form.Item name='date_range' label='起止日期'>
                        <DatePicker.RangePicker />
                    </Form.Item>
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon 
                                type='search' 
                                onClick={() => {
                                    form.submit()
                                    setQuery(prev => ({
                                        ...prev,
                                        date_s: dayjs(form.getFieldValue('date_range')[0]).format('YYYY-MM-DD'),
                                        date_e: dayjs(form.getFieldValue('date_range')[1]).format('YYYY-MM-DD'),
                                    }))
                                }}
                            />
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setList([]);
                                    setQuery(prev => ({
                                        ...prev,
                                        date_s: '',
                                        date_e: '',
                                        kh_id: '',
                                    }))
                                    localStorage.removeItem('jtg-caiwu_arap_client_detail_date_s')
                                    localStorage.removeItem('jtg-caiwu_arap_client_detail_date_e')
                                    localStorage.removeItem('jtg-caiwu_arap_client_detail_kh_id')
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={Array.isArray(list) ? list : []} 
                rowKey={(record) => record.danju_id + record.danju_type}
                bordered
                size='small'
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'10',
                    showTotal:(total) => `共${total}条`,
                }}
                className={classes.customTable}
                style={{marginTop:"10px",width:'100%'}}
                summary={pageData => {                    
                    const total_amount_by_type = pageData.reduce((sum, row) => {
                        let amt = 0;
                        if (row.danju_zflx === '应收' || row.danju_zflx === '核销应付') {
                            amt = Number(row.danju_amount) || 0;
                        } else if (row.danju_zflx === '应付' || row.danju_zflx === '核销应收') {
                            amt = -(Number(row.danju_amount) || 0);
                        } else {
                            amt = 0;
                        }
                        return sum + amt;
                    }, 0);
                    let total
                    if(total_amount_by_type>0){
                        total = <span style={{color:'red'}}>应收：￥{formatAmount(total_amount_by_type)}</span>;
                    }else if(total_amount_by_type<0){
                        total = <span style={{color:'green'}}>应付：￥{formatAmount(total_amount_by_type)}</span>;
                    }else{
                        total = <span>￥{formatAmount(0.00)}</span>;
                    }

                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-3" index={3}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-4" index={4} colSpan={1}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-5" index={5} colSpan={1}>{total}</Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-6" index={6} colSpan={1}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-7" index={7} colSpan={1}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }} 
            />
        </>
    )
}

export default StatisticArapClientDetail